import { useEffect } from 'react';
import {
  getBreakUntilMs,
  getBreakPanelClosed,
  setBreakPanelClosed
} from '../../utils/breakSessionStorage';

/**
 * While the break timer is hidden during countdown, capture pointer events so no control
 * underneath receives clicks; first interaction reopens the break dialog.
 */
export default function BreakPointerCapture() {
  useEffect(() => {
    const onPointerDown = (e) => {
      // Do not steal clicks from the idle acknowledgment dialog (must allow punch-in).
      const raw = e.target;
      const t = raw && raw.nodeType === 1 ? raw : raw?.parentElement;
      if (t && typeof t.closest === 'function' && t.closest('[data-erp4c-idle-ack]')) {
        return;
      }
      const until = getBreakUntilMs();
      if (until == null) return;
      if (Date.now() >= until) return;
      if (!getBreakPanelClosed()) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      setBreakPanelClosed(false);
      window.dispatchEvent(new CustomEvent('erp4cBreakPanelReopen'));
    };
    document.addEventListener('pointerdown', onPointerDown, true);
    return () => document.removeEventListener('pointerdown', onPointerDown, true);
  }, []);
  return null;
}
